var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubmitSuccess = function SvgSubmitSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#D1FADF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#ECFDF3",
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.27 23.408a10.5 10.5 0 1 0 6.227 9.597v-1.072a1.167 1.167 0 0 1 2.334 0v1.073A12.835 12.835 0 0 1 28.55 45.037a12.833 12.833 0 1 1 9.67-23.76 1.167 1.167 0 0 1-.95 2.131m8.219-.567a1.167 1.167 0 0 1 0 1.65L33.823 36.169a1.167 1.167 0 0 1-1.65 0l-3.5-3.5a1.167 1.167 0 1 1 1.65-1.65l2.674 2.675 10.842-10.853a1.167 1.167 0 0 1 1.65 0",
    fill: "#017C07"
  })));
};
export { SvgSubmitSuccess as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjYiIGhlaWdodD0iNjYiIHZpZXdCb3g9IjAgMCA2NiA2NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB4PSI1IiB5PSI1IiB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIHJ4PSIyOCIgZmlsbD0iI0QxRkFERiIvPjxyZWN0IHg9IjUiIHk9IjUiIHdpZHRoPSI1NiIgaGVpZ2h0PSI1NiIgcng9IjI4IiBzdHJva2U9IiNFQ0ZERjMiIHN0cm9rZS13aWR0aD0iMTAiLz48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTM3LjI3IDIzLjQwOGExMC41IDEwLjUgMCAxIDAgNi4yMjcgOS41OTd2LTEuMDcyYTEuMTY3IDEuMTY3IDAgMCAxIDIuMzM0IDB2MS4wNzNBMTIuODM1IDEyLjgzNSAwIDAgMSAyOC41NSA0NS4wMzdhMTIuODMzIDEyLjgzMyAwIDEgMSA5LjY3LTIzLjc2IDEuMTY3IDEuMTY3IDAgMCAxLS45NSAyLjEzMW04LjIxOS0uNTY3YTEuMTY3IDEuMTY3IDAgMCAxIDAgMS42NUwzMy44MjMgMzYuMTY5YTEuMTY3IDEuMTY3IDAgMCAxLTEuNjUgMGwtMy41LTMuNWExLjE2NyAxLjE2NyAwIDEgMSAxLjY1LTEuNjVsMi42NzQgMi42NzUgMTAuODQyLTEwLjg1M2ExLjE2NyAxLjE2NyAwIDAgMSAxLjY1IDAiIGZpbGw9IiMwMTdDMDciLz48L3N2Zz4K";